import styled from 'styled-components';

export const ContentQuotesForm = styled.div`
  margin-top: 1rem;
  .quotes-container {
    min-height: 200px;
    overflow-y: scroll;
    // resize: vertical;
    .header {
      font-weight: bold;
    }
  }
`;
